import AfterDive from '@luketclancy/otterly/after_dive.js'
AfterDive.inner_html = AfterDive.innerHtml
AfterDive.set_data = AfterDive.setData
export default AfterDive